import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    paper: {
        width: "45%",
        color: theme.secondaryColor,
        background: theme.primaryColor
    },
    input: {
        marginBottom: theme.spacing(6),
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
        flex: 1
    },
    backdropFull: {
        width: "100%",
        height: "100%",
        position: "absolute",
        color: "primary",
        zIndex: 100000
    },      
    tableWrapper: {
        width: "100%",
        maxHeight: "70vh",
        overflow: "auto",
        fontFamily: "courier",
        padding: "20px 20px 60px 10px",
        marginLeft: '15px',
        marginRight: '15px',
    },
    box: {
        padding: "20px 20px 60px 10px",
        marginLeft: '15px',
        marginRight: '15px',
        background: "#f8f8f8",
        overflow: "auto",
        marginBottom: "20px",
    },
    tableBorder: {
        marginTop: theme.spacing(4),
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        display: "flex",
        flexDirection: "row"
    },
    tabStyling: {
        "&:hover": {
            background: '#E5E7E9'
        },
        fontWeight: 'bold'
    },
    tableBorder1: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        border: "0.8px solid #00000021",
        paddingBottom: theme.spacing(2),
    },
    listBorder: {
        border: "0.8px solid #00000021"
    },
    tableColumn: {
        fontWeight: 'bold',
        textAlign: 'center',
        fontSize: '0.95rem',
    },
    tableValueList: {
        textAlign: 'center',
        fontSize: '0.85rem',
    },
    table: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        border: "0.8px solid #00000021",
        marginBottom: theme.spacing(2),
    },
    tabHeading: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
    },
    formContainer: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "flex-end",
        paddingRight: theme.spacing(4)
    },

    hiddenField: {
        visibility: "hidden",
        padding: "20px",
        maxHeight: theme.spacing(3)
    },
    fileUploadWrapper: {
        background: "#f8f8f8",
        display: "flex",
        alignItems: "center",
        borderRadius: "5px",
    },
    fileCriteriaLabel: {
        display: "flex",
        justifyContent: "space-between"
    },
    tableTitleDiv: {
        display: "flex",
        paddingLeft: "15px",
        paddingRight: "15px",
        marginLeft: theme.spacing(1.6),
        flexDirection: 'row',
        fontFamily: 'Times New Roman'
    },
    tableTitleDiv2: {
        display: "flex",
        paddingLeft: "15px",
        paddingRight: "15px",
        marginLeft: theme.spacing(1.6),
        marginRight: theme.spacing(1.6),
        flexDirection: 'row',
        fontFamily: 'Times New Roman',
        borderTop: "5px solid #173a64",
    },
    tableTitle: {
        display: "flex",
    },
    backIcon: {
        marginTop: "20px",
        marginRight: theme.spacing(1),
    },
    tableHeadRight: {
        float: "right",
        display: "flex",
        justifyContent: "flex-end",
        width: "100%"
    },
    tableHead: {
        backgroundColor: "9E9E9E"
    },
    root: {
        width: "100%",
        background: "white",
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingTop: theme.spacing(4),
    },

    paper_root: {
        display: 'flex',
        flexDirection: 'row',
        marginLeft: '5px',
    },
    boxDetails: {
        background: "#f8f8f8",
        marginTop: "50px",
        marginLeft: '15px',
        marginRight: '15px',
        wordBreak: "break-all",
    },
    submitButtonDiv: {
        minHeight: "5vh",
        paddingLeft: "1rem",
        minWidth: '7vw'
    },
    submitFilterButton: {
        marginRight: "1rem",
        float: "right",
    },
    formControl: {
        paddingRight: "0.5rem",
        minWidth: 200,
        maxWidth: 250,
        marginTop: theme.spacing(5),
        paddingBottom: '0px',
    },
    detailsDiv2: {
        minWidth: '45vw',
        maxWidth: '50vw',
        padding: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: theme.spacing(1),
        paddingTop: theme.spacing(1),
    },
    detailsDiv: {
        minWidth: '55vw',
        maxWidth: '55vw',
        padding: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: theme.spacing(1),
    },
    detailsDiv1: {
        minWidth: '35vw',
        maxWidth: '35vw',
        padding: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: theme.spacing(1),
    },
    smallTextIcon: {

    },
    detailsDivSpan: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    detailsLabel: {
        fontWeight: 'bold',
        padding: theme.spacing(0.5),
        fontSize: '0.95rem',
    },
    detailsValue: {
        paddingTop: theme.spacing(1),
        fontSize: '0.95rem',
    },
    detailsLogs: {
        fontWeight: 'bold',
        padding: theme.spacing(3),
        paddingTop: '0px'
    },
    inputBox: {
        // marginTop: theme.spacing(),
        marginLeft: theme.spacing(2),
        width: theme.spacing(42),
        marginRight: theme.spacing(3),
        // borderColor: 'black',
    },
    inputBox2: {
        // marginTop: theme.spacing(),
        marginLeft: theme.spacing(15),
        width: theme.spacing(30),
        marginRight: theme.spacing(13),
        // borderColor: 'black',
    },
    errorText: {
        display: 'flex',
        float: "left",
        // flexDirection: 'column',
        padding: theme.spacing(3),
        color: 'red',
        fontWeight: 'bold',
        paddingBottom: '2px',
    },
    labelRoot: {
        fontSize: 16,
        "&$labelFocused": {
            fontSize: 16,
        }
    },
    labelFocused: {},
    latestLicenseHeading: {
        paddingLeft: theme.spacing(2),
        paddingTop: "0px",
        paddingRight: theme.spacing(2),
    },
    mainTabText: {
        padding: theme.spacing(2),
        textAlign: 'center',
        fontSize: '0.95rem'
    },
    tableRow: {
        "&.Mui-selected, &.Mui-selected:hover": {
            backgroundColor: "#E4E7E9"
        }
    },
    searchIcon: {
        marginTop: theme.spacing(1),
    },
    searchBox: {
        borderBottom: "0.8px solid #00000021",
        display: 'flex',
        height: theme.spacing(5),
        borderWidth: theme.spacing(8),
    },
    tableHeadRight: {
        display: "flex",
        justifyContent: "flex-end",
        width: "80%"
    },
    tasksPanelDiv: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(1.5)
    },
    treeViewCollapsableTabs: {
        background: "#ffffff",
        border: "0.5px solid #00000021",
        fontWeight: "bold",
        borderRadius: "2px",
        boxShadow: "2px 2px 10px -5px",
        height: theme.spacing(10)
    },
    taskPanelLabel: {
        fontWeight: "bold",
        fontSize: theme.spacing(2.5)
    },
    tableProp: {
        background: "#f8f8f8",
    },
    refreshTaskBtn: {
        float: "right",
        marginTop: "15px",
        marginBottom: "15px",
        marginRight: "15px",
        paddingLeft: "5px",
        paddingRight: "5px"
    },
    tableContainer: {
        padding: "20px",
        paddingTop: "30px"
    },
    tableBorder2: {
        border: "0.8px solid #00000021",
    },
    tableHeadRow: {
        fontWeight: "700"
    },
    tableContainer: {
        padding: "20px",
        paddingTop: "30px"
    },
    tableFooterDiv: {
        display: "flex"
    },
    tableFooterNoteDiv: {
        width: "100%",
        paddingLeft: "1.5rem",
        marginTop: "0.25rem"
    },
    tablePaginationDiv: {
        marginTop: "-0.75rem",
        width: "100%",
        justifyContent: "flex-end",
        marginRight: theme.spacing(1),
    },
    taskTablePaginationDiv: {
        marginTop: "0.25rem",
        width: "100%",
        justifyContent: "flex-end",
        marginRight: theme.spacing(1),
    },
    noRecordsRow: {
        background: "#ffffff"
    },
    dividerStyling: {
        marginLeft: theme.spacing(4),
        marginRight: theme.spacing(4),
    },
    dialogTitleX: {
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
    },
    dialogButtonX: {
        padding: '0px',
    },
    detailsDivDialog: {
        padding: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: theme.spacing(1),
        maxWidth: '45rem'
    },
    detailsDivSpan: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    detailsLabelDialog: {
        fontWeight: 'bold',
        paddingTop: theme.spacing(0.5),
        // paddingRight: '0.5px',
        fontSize: '0.95rem',
    },
    retryButtonDiv: {
        marginTop: "1rem",
        marginLeft: "0.5rem"
    },
    resubmitButton: {
        marginLeft: "1rem",
        float: "left",
    },
    dialogBoxDetailDiv: {
        display: 'flex',
        padding: theme.spacing(3),
        justifyContent: 'space-between'
    },
    dialogDispatcherDetailDiv: {
        display: 'block',
        // minWidth: '38rem'
    },
    detailsLogsDialog: {
        fontWeight: 'bold',
        paddingTop: '0px',
        paddingBottom: '1px',
        fontSize: '0.95rem',
    },
    box1: {
        display: "block",
        border: "1px solid #C6C6C6",
        marginTop: '15px',
        marginRight: '15px',
        marginBottom: '1.5rem',
        wordBreak: "break-all",
        minHeight: '60vh',
        maxHeight: '60vh',
        paddingBottom: '5px',
        overflow: 'scroll',
        minWidth: '70rem'
    },
    box2: {
        display: "block",
        border: "1px solid #C6C6C6",
        marginTop: '15px',
        marginRight: '15px',
        marginBottom: '1.5rem',
        wordBreak: "break-all",
        minHeight: '60vh',
        maxHeight: '60vh',
        paddingBottom: '5px',
        overflow: 'scroll',
        minWidth: '38rem',
        maxWidth: '38rem'
    },
    replicatorPayloadDiv: {
        marginTop: "1rem"
    },
    root_2: {
        width: "100%",
        background: "white",
        padding: theme.spacing(2)
    },
    backButton:{
        padding: 0,
        minWidth: 'auto',
        fontSize: '1rem',
        textTransform: 'none',
        fontFamily: 'PilatLight',
        marginBottom: '12px'
    }
}));
  
export default useStyles;